import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchReviewerQueue,
  fetchReviewerSummary,
  type ReviewerQueueResponse,
  type ReviewerSummaryResponse,
} from '../../request/analytics/reviewerReports.ts';
import { analyticsReviewerQueryKeys } from '../../queries/analytics/keys.ts';

/**
 * React Query v5 hooks for the new Reviewer persona dashboard (6th persona,
 * dashboard_key 'reviewer', feedback round 2026-08). Read-only, same pattern
 * as the External Auditor hooks.
 */

export function useReviewerQueue(): UseQueryResult<ReviewerQueueResponse, Error> {
  return useQuery({ queryKey: analyticsReviewerQueryKeys.queue(), queryFn: fetchReviewerQueue });
}

export function useReviewerSummary(): UseQueryResult<ReviewerSummaryResponse, Error> {
  return useQuery({ queryKey: analyticsReviewerQueryKeys.summary(), queryFn: fetchReviewerSummary });
}
